export const downloadB64File = (binary: string) => {
  let a = document.createElement('a');
  a.href = `data:application/xlsx;base64,${binary}`;
  a.download = 'evskReport.xlsx';
  a.click();
};
